module.exports = __webpack_public_path__ + "img/Team_photo_IMG_4626_960x224.3701abed.jpg";